import type { ApiError, ApiErrorCode } from "@9amhealth/openapi";
import reportErrorSentry from "src/lib/reportErrorSentry";

/**
 * Stands in for "the response carried no error code". Callers treat the
 * formatted code as an opaque, always-truthy string — both as translation
 * context and as the signal that a request failed at all — so it must not
 * become empty when the code is missing.
 */
export const NO_ERROR_CODE = "0";

export const extractErrorCode = (error: unknown): ApiErrorCode | undefined => {
  try {
    const code = (error as ApiError | undefined)?.body?.code;
    if (code !== undefined && code !== null) {
      return Number(code) as ApiErrorCode;
    }
  } catch (e: unknown) {
    reportErrorSentry(e);
  }

  return undefined;
};

export const extractErrorCodeString = (error: unknown): string => {
  const code = extractErrorCode(error);
  return code === undefined ? NO_ERROR_CODE : `${code}`;
};
